// src/layouts/MainLayout.jsx
import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";

export default function MainLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="app-shell text-[var(--fg)]">
      <div className="flex min-h-screen">
        <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

        <div className="flex-1 flex flex-col pt-1 min-w-0">
          <Header onMenuToggle={() => setSidebarOpen(true)} />

          <main className="py-3 px-4 md:px-6 lg:px-8 pb-6 overflow-x-auto">
            <div className="surface-card rounded-2xl p-3 md:p-4 lg:p-5 max-w-full w-full overflow-visible">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}
